import React, { Component } from 'react';
import { ValidationRules } from '../Functions/Validation';

export class Input extends Component {
    constructor(props) {
        super(props);

        this.state = {
            hasError: false,
            errorDisplay: [],
            matchMessage: this.props.matchMessage
        }

        this.handleChange = this.handleChange.bind(this);
    }
              
    checkForm() {
        return this.handleChange(this.input.current, true);
    }

    handleChange(event, isSubmit = false) {
        event = event.target || event;
        var e = event.value;
        var messageVal = [];
        var hasErrorVal = false;

        if ((e == "" || e == null) && this.props.required) {
            messageVal.push(this.props.requiredMessage);
            hasErrorVal = true;
        } else if (e != "" && e != null) {
            var { rules } = this.props;
            if (!(rules instanceof Array)) {
                for (var item in rules) {
                    if (typeof rules[item] == "object") {
                        var v;
                        if (item.indexOf("pattern") >= 0) {
                            v = ValidationRules[item](e, rules[item].regex, rules[item].message);
                        } else if (item.indexOf("minLength") >= 0) {
                            v = ValidationRules[item](e, rules[item].len, rules[item].message);
                        } else if (item.indexOf("custom") >= 0) {
                            v = ValidationRules[item](e, rules[item].bool, rules[item].message);
                        }  else if (item.indexOf("minValue") >= 0) {
                            v = ValidationRules[item](e, rules[item].min, rules[item].message);
                        } else {
                            v = ValidationRules[item](e, rules[item].message);
                        }

                        if (v != null && v != undefined) {
                            if (!v.result) {
                                messageVal.push(v.message);
                                hasErrorVal = true;
                            }
                        }
                    }
                }
            } else {
                rules.forEach((item, index) => {
                    if (typeof item == "object") {
                        for (var i in item) {
                            var v;
                            if (i.indexOf("pattern") >= 0) {
                                v = ValidationRules[i](e, item[i].regex, item[i].message);
                            } else if (i.indexOf("minLength") >= 0) {
                                v = ValidationRules[i](e, item[i].len, item[i].message);
                            } else if (i.indexOf("custom") >= 0) {
                                v = ValidationRules[i](e, item[i].bool, item[i].message);
                            } else if (item.indexOf("minValue") >= 0) {
                                v = ValidationRules[i](e, item[i].min, item[i].message);
                            } else {
                                v = ValidationRules[i](e, item[i].message);
                            }

                            if (v != null && v != undefined) {
                                if (!v.result) {
                                    messageVal.push(v.message);
                                    hasErrorVal = true;
                                }
                            }
                        }
                    } else if (typeof item == "string") {
                        var v = ValidationRules[item](e);
                        if (!v.result) {
                            messageVal.push(v.message);
                            hasErrorVal = true;
                        }
                    }
                })
            }            
        }

        if (this.props.matchString) {
            if (e != this.props.stringToMatch) {
                messageVal.push(this.props.matchMessage);
                hasErrorVal = true;
            }
        }
        
        this.setState({
            errorDisplay: messageVal,
            hasError: hasErrorVal
        }, () => { this.props.isValid(!hasErrorVal) });      

        return !hasErrorVal;
    }
    
    render() {
        return (
            <div className={this.props.wrapperClass}>
                <input
                    ref={this.input = React.createRef()}
                    placeholder={this.props.placeholder}
                    type={this.props.type}
                    className={"form-control " + (this.state.hasError? "error" : "")}
                    value={this.props.value}
                    onChange={(e) => this.props.onChange(e)}
                    onBlur={(e) => this.handleChange(e)}
                />
                {
                    this.state.hasError && 
                    <div className="ErrorContainer">
                        {
                            this.state.errorDisplay.map((item, index) => {
                                return <div key={index} className="error">{item}</div>
                            })
                        }
                    </div>
                }
            </div>
        );
    }
}

Input.defaultProps = {
    wrapperClass: "form-group",
    rules: [],
    type: "text",
    placeholder: "",
    required: false,
    isValid: (e) => { },
    requiredMessage: "This field is required",
    errorMessage: "",
    getPhoneType: (e) => { },
    matchString: false,
    matchMessage: "The two strings do not match"
}


// WEBPACK FOOTER //
// ./src/components/Input.js